import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchHubspotIntegration } from "./api"

export function useFetchHubspotIntegration() {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["hubspot-integration"],
    queryFn: async () => {
      const context = await getContext()
      return fetchHubspotIntegration(context)
    },
  })
}
